import changePasswordModal from "@/components/modal/ChangePassword/index.vue";
import changePhonenumberModal from "@/components/modal/ChangePhoneNumber/index.vue";
import changeNameModal from "@/components/modal/ChangeName/index.vue";
import channelTalk from "@/helpers/channelTalk";
import vatInfoModal from "@/components/modal/vatInformation/layout.vue";
import toast from "./toast.vue";
import dayjs from "dayjs";

export default {
  metaInfo: {
    title: "회원정보"
  },
  data() {
    return {
      visible: true,
      isLoading: false,
      type: "",
      modalStatus: {
        changePassword: false,
        changePhoneNumber: false,
        changeName: false,
        changeVatInfo: false
      },
      userInfo: {
        vatInfo: {
          companyName: "",
          vatNumber: "",
          email: "",
          licenseImage: "",
          address: "",
          conditions: "",
          representative: ""
        },
        name: "",
        phoneNumber: "",
        userId: ""
      },
      toastList: []
    };
  },
  components: {
    changePasswordModal,
    changePhonenumberModal,
    changeNameModal,
    vatInfoModal,
    toast
  },
  methods: {
    // apple
    isApple() {
      return localStorage.getItem("isApple") ? true : false;
    },
    appleIsRequestDelete() {
      const cofirm2 = confirm("계정이 삭제 됩니다. 진행하겠습니까?");
      if (!cofirm2) return;
      localStorage.setItem("appleIsDeleted", "ok");
      this.$store.dispatch("auth/signout");
      channelTalk.shutdown();
      this.$router.push("/");
    },
    async setInfo() {
      this.isLoading = true;
      try {
        const type = this.$store.getters["auth/tokenPayload"]().type;
        const result =
          this.$store.getters["auth/tokenPayload"]().type === "member"
            ? await this.$store.dispatch("users/biz_member_myInfo")
            : await this.$store.dispatch("users/biz_manager_myInfo");

        if (!result.success) return;
        this.userInfo = result.information;
        if (type === "member" && this.userInfo.approved !== "approved") {
          this.visible = false;
        }
      } catch (e) {
        await this.$store.dispatch("auth/signout");
        this.$router.push("/");
      } finally {
        this.isLoading = false;
      }
    },

    async changeAgreement(isAgree) {
      if (this.userInfo.isAgreedToMarketing === isAgree) return;
      const payload = {
        isAgreedToMarketing: isAgree
      };
      try {
        const result = await this.$store.dispatch(
          "users/biz_agreeToMarketing",
          payload
        );

        if (result.success) {
          this.toast(
            isAgree
              ? "이벤트 정보 수신을 동의합니다."
              : "이벤트 정보 수신을 거부합니다."
          );
          this.userInfo.isAgreedToMarketing = isAgree;
        }
      } catch (e) {
        alert("서버에러가 발생하였습니다.");
      }
    },

    async updateAlimTalk(key, isAgree) {
      try {
        const payload = { [key]: isAgree };

        const result = await this.$store.dispatch(
          "users/biz_agreedToAlim",
          payload
        );

        if (result.success) {
          this.toast(
            isAgree
              ? "배송현황 알림톡 수신을 동의합니다."
              : "배송현황 알림톡 수신을 거부합니다."
          );
        }
      } catch (e) {
        alert("서버에러가 발생하였습니다.");
      }
    },

    toast(string) {
      this.toastList.push({
        msg: string,
        date: dayjs().valueOf()
      });

      setTimeout(() => {
        this.toastList.shift();
      }, 3000);
    }
  },
  async mounted() {
    await this.setInfo();
  },
  destroyed() {},
  computed: {
    memberType() {
      const type = this.$store.getters["auth/tokenPayload"]().type;
      this.type = type;
      if (type === "member") {
        return "구성원";
      } else if (type === "manager") {
        return "관리자";
      } else {
        return "ERROR";
      }
    }
  }
};
